import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@shared/ui/dialog";
import { Button } from "@shared/ui/button";
import { RotateCcw } from "lucide-react";
import { ValidationBreakReadingItem } from "@features/mx/validations/types";

interface RevertReadingProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  data: any | null; // We use 'any' to be safe, but it's likely ValidationBreakReadingItem
  loading?: boolean;
}

export const RevertReadingModal = ({ open, onClose, onConfirm, data, loading }: RevertReadingProps) => {
  if (!data) return null;


  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[425px] p-6">
        <div className="flex gap-4">
          <div className="w-12 h-12 rounded-full bg-red-50 flex items-center justify-center shrink-0">
            <RotateCcw className="w-6 h-6 text-red-500" />
          </div>
          <div className="space-y-1">
            <h2 className="text-xl font-semibold leading-none tracking-tight">Revert Reading</h2>
            <p className="text-sm text-muted-foreground">This action will move the read back to Pending.</p>
          </div>
        </div>

        <div className="bg-muted/50 rounded-lg border p-4 space-y-3 my-2">
          <div className="flex justify-between items-center text-sm">
            <span className="text-muted-foreground">Resource ID</span>
            <span className="font-medium text-blue-600">{data.resourceId || "N/A"}</span>
          </div>
          <div className="flex justify-between items-center text-sm">
            <span className="text-muted-foreground">Serial No</span>
            <span className="font-medium">{data.serialNo || "N/A"}</span>
          </div>
          <div className="flex justify-between items-center text-sm">
            <span className="text-muted-foreground">Consumer</span>
            <span className="font-medium">{data.consumerName}</span>
          </div>
          <div className="flex justify-between items-center text-sm">
            <span className="text-muted-foreground">Current Reading</span>
            <span className="font-medium">{data.currentReading ?? "N/A"}</span>
          </div>
        </div>

        <div className="flex justify-end gap-3 mt-4">
          <Button variant="outline" onClick={onClose} disabled={loading}>
            Cancel
          </Button>
          <Button variant="destructive" onClick={onConfirm} disabled={loading} className="bg-red-500 hover:bg-red-600">
            Confirm Revert
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
